// CHA-302 — client twin of functions/usWarehouses.js.
//
// The frontend cannot require() from functions/, so the list exists twice. The region between the
// CANONICAL markers is asserted BYTE-IDENTICAL to the server file by
// functions/__tests__/usWarehouses.test.js — same drift guard as the costSheetRules.js twin (CHA-289).
// Edit the region in one file and copy it verbatim into the other; hand-editing both is how the
// original six copies drifted in the first place.
//
// See the server file for what membership means (US destination warehouses only — Canada and direct
// import are deliberately absent) and what the coast is for.

/* ---- CANONICAL REGION START — keep byte-identical with the client twin ---- */
const US_WAREHOUSES = [
  { code: 'LAP', coast: 'west' },
  { code: 'RLA', coast: 'west' },
  { code: 'CLS', coast: 'west' },
  { code: 'SCN', coast: 'west' },
  { code: 'DYN', coast: 'west' },
  { code: 'BCC', coast: 'west' },
  { code: 'BL', coast: 'east' },
  { code: 'PON', coast: 'east' },
  { code: 'POL', coast: 'west' },
  { code: 'SCG', coast: 'east' },
];

const US_WAREHOUSE_CODES = US_WAREHOUSES.map((w) => w.code);
/* ---- CANONICAL REGION END ---- */

export { US_WAREHOUSES, US_WAREHOUSE_CODES };
